import { render } from "./Finance.vue?vue&type=template&id=296c8d1d&scoped=true"
import script from "./Finance.vue?vue&type=script&lang=js"
export * from "./Finance.vue?vue&type=script&lang=js"

import "./Finance.vue?vue&type=style&index=0&id=296c8d1d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296c8d1d"]])

export default __exports__